import React, {Component} from 'react'
import {connect} from 'react-redux'
import LoginActions from '../reducers/login/LoginRedux'
import {Redirect} from 'react-router-dom'
import '../assets/App.css'
import _ from 'lodash'
import {
    Row,
    Col,
    Icon,
    Grid,
    Form,
    Panel,
    Button,
    PanelBody,
    FormGroup,
    InputGroup,
    FormControl,
    PanelContainer,
    HelpBlock
} from '@sketchpixy/rubix'
import {ERROR_MESSAGES, FIELD_STATUSES} from '../utils'
import NotificationSystem from 'react-notification-system'
//import {ADMIN_ROLE, isAuthorized, APP_ADMIN_ROLE} from '../utils/index'

class ResetPasswordPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showSuccessMessage: false,
            updatingPassword: false,
            password: '',
            confirmPassword: '',
            authenticate: !!this.props.loginToken,
            confirmPasswordError: {
                status: null,
                message: ''
            },
            passwordError: {
                status: null,
                message: ''
            },
            tokenError: {
                status: null,
                message: ''
            }
        }
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
    }

    _addNotification = (message, type, title) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title: title,
            level: type,
            autoDismiss: 2
        })

        if (type === 'error') {
            this.setState({
                emailError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                },
                passwordError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                },
                tokenError: {
                    status: null,
                    message: ''
                }
            })
        }
    }

    componentWillReceiveProps(newProps) {
        const {fetching, error} = newProps
        const {updatingPassword} = this.state;

        if (newProps.loginToken) {
            this.setState({
                updatingPassword: false,
                authenticate: true
            })
        }
        if (updatingPassword && !fetching && !error) {
            this.setState({
                updatingPassword: false,
                showSuccessMessage: true
            }, () => {
                this._addNotification('Password Reset Successful', 'success', 'Password Reset Message: ');
            })
        }
        if (!fetching && error) {
            this.setState({
                updatingPassword: false,
            }, () => {
                this._addNotification(error, 'error', 'Error Message: ');
            })

        }
    }

    handleInputChange = ({target: {name, value}}) => {
        this.setState({
            [name]: value,
            confirmPasswordError: {
                status: null,
                message: ''
            },
            passwordError: {
                status: null,
                message: ''
            },
            tokenError: {
                status: null,
                message: ''
            }
        })
    }

    handleFieldValidations = (resetPasswordToken) => {
        const {confirmPassword, password} = this.state;

        let [confirmPasswordError, passwordError, tokenError, errorExist] = [{}, {}, {}, false]

        if (!resetPasswordToken) {
            // tokenError.status = FIELD_STATUSES.ERROR
            // tokenError.message = ERROR_MESSAGES.RESET_TOKEN_MISSING
            // errorExist = true
            this._addNotification('Reset Password Token is Missing', 'error', 'Error Message: ');
        }

        if (!password) {
            passwordError.status = FIELD_STATUSES.ERROR
            passwordError.message = ERROR_MESSAGES.PASSWORD_ERROR_MESSAGE
            errorExist = true
        }


        if (!confirmPassword) {
            confirmPasswordError.status = FIELD_STATUSES.ERROR
            confirmPasswordError.message = ERROR_MESSAGES.PASSWORD_ERROR_MESSAGE
            errorExist = true
        }

        if (password && confirmPassword && !_.isEqual(password, confirmPassword)) {
            confirmPasswordError = {
                status: FIELD_STATUSES.ERROR,
                message: ERROR_MESSAGES.COMPARE_NEW_PASSWORD_MISMATCH
            }
            errorExist = true
        }

        return {confirmPasswordError, passwordError, tokenError, errorExist}
    }

    pressReset = (e) => {
        e.preventDefault()
        e.stopPropagation()

        const {match} = this.props;
        const {resetPasswordToken} = match.params;

        const {confirmPasswordError, passwordError, tokenError, errorExist} = this.handleFieldValidations(resetPasswordToken)

        if (errorExist) {
            this.setState({
                tokenError,
                confirmPasswordError,
                passwordError
            })
        }
        const {confirmPassword, password} = this.state
        if (confirmPassword && password) {
            this.setState({
                updatingPassword: true
            }, () => {
                this.props.resetPasswordRequest(password, resetPasswordToken)
            })
        }
    }

    render() {
        const {
            showSuccessMessage = false,
            authenticate = false,
            confirmPassword,
            password,
            confirmPasswordError: {status: confirmPasswordStatus, message: confirmPasswordError},
            passwordError: {status: passwordStatus, message: passwordError}
        } = this.state;

        if (authenticate) {
            console.log("this.props.location.state:: ", this.props.location.state)
            let {from} = this.props.location.state || {from: '/admin/dashboard'}
            return (
                <Redirect to={from}/>
            )
        }

        return (
            <div id='auth-container'>
                <div id='auth-row'>
                    <div id='auth-cell'>
                        <Grid>
                            <Row>
                                <Col sm={4} smOffset={4} xs={10} xsOffset={1} collapseLeft collapseRight>
                                    <PanelContainer controls={false}>
                                        <Panel>
                                            <PanelBody style={{padding: 0}}>
                                                <div className='text-center bg-darkblue fg-white'>
                                                    <h3 style={{margin: 0, padding: 25}}>Reset Password for Fastvet</h3>
                                                </div>
                                                <div className='bg-hoverblue fg-black50 text-center'
                                                     style={{padding: 12.5}}>
                                                    <div> {showSuccessMessage ?
                                                        'Password Reset Successful'
                                                        : 'Please fill the form below to reset your password'}</div>
                                                </div>
                                                {showSuccessMessage ?
                                                    <div className="text-center">
                                                        <div style={{
                                                            padding: '0px 25px',
                                                            margin: '25px auto',
                                                            height: '70px',
                                                            fontSize: '18px'
                                                        }}>
                                                            Password is updated. <a className="fg-darkblue" href="/">Please Login again!</a>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div>
                                                        <div style={{
                                                            padding: 25,
                                                            paddingTop: 0,
                                                            paddingBottom: 0,
                                                            margin: 'auto',
                                                            marginBottom: 25,
                                                            marginTop: 25
                                                        }}>
                                                            <Form>
                                                                <FormGroup controlId='password'
                                                                           validationState={passwordStatus}>
                                                                    <InputGroup bsSize='large'>
                                                                        <InputGroup.Addon>
                                                                            <Icon glyph='icon-fontello-key'/>
                                                                        </InputGroup.Addon>
                                                                        <FormControl
                                                                            autoFocus
                                                                            type='password'
                                                                            className='border-focus-blue'
                                                                            name='password'
                                                                            placeholder='New Password'
                                                                            onChange={this.handleInputChange}
                                                                            value={password}/>
                                                                    </InputGroup>
                                                                    <HelpBlock>{passwordError}</HelpBlock>
                                                                </FormGroup>

                                                                <FormGroup controlId='confirmPassword'
                                                                           validationState={confirmPasswordStatus}>
                                                                    <InputGroup bsSize='large'>
                                                                        <InputGroup.Addon>
                                                                            <Icon glyph='icon-fontello-key'/>
                                                                        </InputGroup.Addon>
                                                                        <FormControl
                                                                            type='password'
                                                                            className='border-focus-blue required'
                                                                            placeholder='Confirm password'
                                                                            name='confirmPassword'
                                                                            onChange={this.handleInputChange}
                                                                            value={confirmPassword}/>
                                                                    </InputGroup>
                                                                    <HelpBlock>{confirmPasswordError}</HelpBlock>
                                                                </FormGroup>

                                                                <NotificationSystem ref='notificationSystem'/>
                                                                <FormGroup>
                                                                    <Grid>
                                                                        <Row style={{marginBottom: 15}}>
                                                                            <Col xs={6} collapseLeft collapseRight/>
                                                                            <Col xs={6} collapseLeft collapseRight
                                                                                 className='text-right'>
                                                                                <Button
                                                                                    outlined
                                                                                    lg
                                                                                    type='submit'
                                                                                    bsStyle='primary'
                                                                                    className="bg-darkblue"
                                                                                    onClick={this.pressReset}
                                                                                >Reset Password</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </Grid>
                                                                </FormGroup>
                                                            </Form>
                                                        </div>
                                                    </div>}
                                            </PanelBody>
                                        </Panel>
                                    </PanelContainer>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </div>
            </div>
        )
    }
}

const
    mapStateToProps = ({login}) => {
        const {resetPasswordToken, error, fetching, loginToken} = login
        return {resetPasswordToken, error, fetching, loginToken}
    }

const
    mapDispatchToProps = dispatch => ({
        resetPasswordRequest: (password, forgotToken) => {
            dispatch(LoginActions.resetPasswordRequest(password, forgotToken))
        }
    })

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage)
